<template>
  <Page title="Clientes">
    <template v-slot:actions>
      <div>
        <v-btn @click="handleAddClient" color="primary" tile>
          <v-icon left>
            mdi-plus
          </v-icon>
          Cadastrar
        </v-btn>
      </div>
    </template>

    <v-container fluid>
      <v-card>
        <v-data-table :items="clients" :headers="headers" :loading="loading">
          <template v-slot:item.name="{ item }">
            <router-link :to="`/admin/clients/${item.id}`">
              {{ item.name }}
            </router-link>
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ formatDateTime(item.created_at) }}
          </template>
          <template v-slot:item.updated_at="{ item }">
            {{ formatDateTime(item.updated_at) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="deleteClient(item)">
                  <v-icon left>mdi-delete</v-icon> Excluir
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="dialog" max-width="650" eagle>
      <ClientsForm ref="form" @submit="saveClient" @cancel="handleCancel" />
    </v-dialog>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import ClientsForm from "@/components/forms/ClientsForm";
import Service from "@/services/ClientsService";
import DateTimeMixin from "@/mixins/DateTimeMixin";

const service = new Service();

export default {
  mixins: [DateTimeMixin],

  data() {
    return {
      dialog: false,
      service,
      clients: [],
      headers: [
        {
          text: "Nome",
          value: "name"
        },
        {
          text: "Criação",
          value: "created_at",
          width: 200
        },
        {
          text: "Atualização",
          value: "updated_at",
          width: 200
        },
        {
          text: "Ações",
          value: "actions",
          align: "right",
          sortable: false,
          width: 70
        }
      ],
      loading: false
    };
  },

  components: { Page, ClientsForm },

  methods: {
    handleAddClient() {
      this.dialog = true;

      if (this.$refs.form) this.$refs.form.init();
    },
    handleCancel() {
      this.dialog = false;
    },
    async saveClient(client) {
      this.$refs.form.loading = true;

      try {
        await this.service.store(client);
        this.handleCancel();
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    async deleteClient(client) {
      if (!confirm("Tem certeza que deseja excluir o cliente?")) return;

      await this.service.destroy(client.id);
      this.getData();
    },
    async getData() {
      this.loading = true;
      this.clients = await this.service.index();
      this.loading = false;
    }
  },

  created() {
    this.getData();
  }
};
</script>
